module.exports = __webpack_public_path__ + "static/babyonboard-9ae411cb29c59141b6bd9289fac7ec16.png";